import { Component, OnInit } from '@angular/core';
import { TransaccionCarrito } from '../../models/transaccionCarrito.model';
import { Router } from '@angular/router';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { HttpErrorResponse } from '@angular/common/http';
import { removeToCar } from '../../redux/actions/carCheckout.actions';
import { removePlanFromCar } from '../../redux/actions/carPlanCheckout.actions';
import { Encrypt } from '../../utils/encrypt/encrypt';
import { UserInformation } from '../../models/userInformation.model';
import { AppState } from '../../app.reducer';
import { Store } from '@ngrx/store';
import { ProductsService } from '../../services/products/products.service';
import { environment } from'@env/environment';
import { MatDialog } from '@angular/material/dialog';
import { CcLoginComponent, CcRegisterComponent, PasswordRecoverComponent } from 'cc-components-lib';

@Component({
  selector: 'app-products-feedback',
  templateUrl: './products-feedback.component.html',
  styleUrls: ['./products-feedback.component.scss']
})

export class ProductsFeedbackComponent implements OnInit {

  transaccionCarrito: TransaccionCarrito;
  isSuccess: boolean = false;
  isPending: boolean = false;
  isWarning: boolean = false;
  userInformation: UserInformation;
  public ccEnvironment: any;


  constructor(
    private router: Router,
    private cookieCiencuadras: CookieCiencuadras,
    private store: Store<AppState>,
    private productsService: ProductsService,
    private dialog: MatDialog

  ) { 
    this.ccEnvironment = environment;
  }

  async ngOnInit(): Promise<void> {
    if(localStorage.getItem('paymentStatus') || this.transaccionCarrito){
      this.transaccionCarrito = JSON.parse(localStorage.getItem('paymentStatus'));
      console.log('transaccionCarrito: ', this.transaccionCarrito);
      
      switch (this.transaccionCarrito.transaccionCarritoDTO.transactionStatusId) {
        case 2:
          this.isPending = true;
          localStorage.removeItem('paymentStatus');
          console.log("pago PAGO_PENDIENTE carrito");
          this.cookieCiencuadras.removeCookie('tokenProduct');
        break;
        case 3:
          this.isPending = true;
          localStorage.removeItem('paymentStatus');
          console.log("pago PENDIENTE_GATEWAY carrito");
          this.cookieCiencuadras.removeCookie('tokenProduct');
        break;

        case 4:
          this.cookieCiencuadras.setCookie('redirectProducts','1')
          localStorage.removeItem('paymentStatus');
          this.isSuccess = true;
          console.log("pago exitoso borrar carrito");
          this.cookieCiencuadras.removeCookie('tokenProduct');
          this.deleteStorageProducts();
          // await this.deleteItemsFromCar();
        break;
        
        case 5:
          this.isWarning = true;
          localStorage.removeItem('paymentStatus');
        break;
      }
    }
  }

  /*
    BORRADOR("Borrador",1),
    PAGO_PENDIENTE("Pago pendiente",2),
    PENDIENTE_GATEWAY("Pendiente Gateway",3),
    EFECTIVAS("Efectivas",4),
    PAGO_RECHAZADO("Pago rechazado",5);
  */

  async button(){
    console.log('button: ', this.transaccionCarrito.transaccionCarritoDTO.transactionStatusId);
    
    switch (this.transaccionCarrito.transaccionCarritoDTO.transactionStatusId) {
      case 2:
        this.router.navigateByUrl('/');
      break;
      case 3:
        this.router.navigateByUrl('/');
      break;

      case 4:
          this.router.navigateByUrl('/zona-de-usuario');
      break;
      
      case 5:
        this.router.navigateByUrl('/arma-tu-plan');
      break;
    }
  }

  deleteStorageProducts(){
    if (localStorage.getItem('__app_storage__') !== null) {
      const objItems = JSON.parse(localStorage.getItem('__app_storage__')!);
      if (objItems.carPlanCheckout.length > 0) {
        this.store.dispatch(removePlanFromCar({ id: objItems.carPlanCheckout[0].id }));
      }
      if (objItems.carCheckout.length > 0) {
        objItems.carCheckout.forEach(product => this.store.dispatch(removeToCar({ id: product.id })))
      }
    }
  }

  OpenOnboardingModal(Onboarding: any){
    console.log("event onboarding -->", Onboarding);

    this.dialog.closeAll();
    if(Onboarding.modal == 1){
      console.log("Onboarding.modal-->", Onboarding.modal);
      this.OpenLoginModal(Onboarding.typeUser);
    }
    if(Onboarding.modal == 2){
      this.OpenRecoverPwModal(Onboarding.typeUser);
    }
    if(Onboarding.modal == 3){
      this.OpenRegisterModal(Onboarding.typeUser);
    }
  }

  OpenLoginModal(typeUser: string){
    let DialogRefLogin = this.dialog.open(CcLoginComponent, {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefLogin.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });

  }

  OpenRecoverPwModal(typeUser: string){
    let DialogRefRecover = this.dialog.open(PasswordRecoverComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefRecover.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRegisterModal(typeUser: string){
    let DialogRefRegister = this.dialog.open(CcRegisterComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefRegister.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

}
